import { z } from 'zod';

// Bizy moment-email consent for the current user (BIZY-727). Default-on:
// missing PersonalBizy / unset field both mean emails are enabled.
export const BizyMomentEmailPreferencesSchema = z.object({
	momentEmailsEnabled: z.boolean(),
});
export type BizyMomentEmailPreferences = z.infer<typeof BizyMomentEmailPreferencesSchema>;

export const bizyMomentEmailPreferencesFixture = (overrides: Partial<BizyMomentEmailPreferences> = {}): BizyMomentEmailPreferences => ({
	momentEmailsEnabled: true,
	...overrides,
});
